import React from 'react'
import { useFormikContext } from 'formik';

import FormSection from '../../common/FormSection';
import FormStep from '../../common/FormStep';
import PleaseExplain from '../../common/PleaseExplain';
import TextareaWithCharCount from '../../common/TextareaWithCharCount';
import YesNoField from '../../common/YesNoField';

const NotTraditionalTraffickingCountermeausers = ({ children }: any) => {
  const { values } = useFormikContext();

  if (values['haveEndingTraffickingPolicy'] === 'False' || values['assessPossibleTrafficking'] === 'False') {
    return children;
  } else {
    return null;
  }
}

const ComplianceFields = () => {
  return (
    <FormStep>
      <FormSection title="N. Combatting Trafficking in Persons">
        <YesNoField
          label="1. As a U.S. government contractor, Afognak Native Corporation, Alutiiq, LLC and their subsidiaries, its subcontractors, and their subcontractors are subject to U.S. Government anti-human trafficking rules, including FAR 52.222-50 - Combatting Trafficking in Persons. Is your company aware of the requirements of this clause?"
          name="awareOfFARClause"
        />

        <YesNoField
          label="2. Afognak Native Corporation's Ending Trafficking in Persons Compliance Plan emphasizes our zero-tolerance policy against human trafficking and trafficking-related activities. Does your company have its own compliance policy prohibiting these activies?"
          name="haveEndingTraffickingPolicy"
        />
        <PleaseExplain name="haveEndingTraffickingPolicy">
          <p>
            Please provide a copy of your policy on the next page. Note: a copy shall be provided to the Contracting Officer upon request.
          </p>
        </PleaseExplain>

        <YesNoField
          label="3. Are employees or contract workers free to terminate employment with your company with reasonable notice?"
          name="freeToTerminate"
        />
        <PleaseExplain name="freeToTerminate" value="False">
          <TextareaWithCharCount label="Please explain" name="freeToTerminateExplanation" required maxCharInput={250} />
        </PleaseExplain>

        <YesNoField
          label="4. Does your company require employees or contract workers to lodge deposits of money with you, or identity or immigration documents such as passports or drivers' licenses, as a condition of their employment with your company?"
          name="depositsRequired"
        />
        <PleaseExplain name="depositsRequired">
          <TextareaWithCharCount label="Please explain" name="depositsRequiredExplanation" required maxCharInput={250} />
        </PleaseExplain>

        <YesNoField
          label="5. Has your company undertaken due diligence to assess whether or not human trafficking and/or trafficking-related activities as outlined in 52.222-50 exists in your supply chain?"
          name="assessPossibleTrafficking"
        />
        <PleaseExplain name="assessPossibleTrafficking">
          <TextareaWithCharCount label="Please explain" name="assessPossibleTraffickingExplanation" required maxCharInput={250} />
          <TextareaWithCharCount
            label="How often will you repeat this due dilligence on your supply chain?"
            name="freqAssessPossibleTrafficking"
            required
            maxCharInput={250}
          />
          <YesNoField
            label="Are you aware of any human trafficking and/or trafficking-related activites as outline in 52.222-50 in your supply chain?"
            name="possibleTrafficking"
          />
          <PleaseExplain name="possibleTrafficking">
            <TextareaWithCharCount label="Please explain" name="possibleTraffickingExplanation" required maxCharInput={500} />
          </PleaseExplain>
        </PleaseExplain>

        <NotTraditionalTraffickingCountermeausers>
          <TextareaWithCharCount
            label="Please explain how your company complies with the requirements of the FAR 52.222-50 - Combating Trafficking in Persons."
            name="otherEndingTraffickingPolicy"
            required
            maxCharInput={500}
          />
        </NotTraditionalTraffickingCountermeausers>
        
        <YesNoField
          label="6. If you discovered that any of your suppliers or sub-suppliers used human trafficking and/or trafficking-related activities as outlined in 52.222-50 within its workforce (or within its own supply chain) would you cease to use that supplier (or seek for your supplier to cease using their sub-supplier)?"
          name="boycottTraffickers"
        />

        <YesNoField
          label="7. Does your company have a written code of business ethics and conduct?"
          name="haveCodeOfBusinessEthicsAndConduct"
        />
        <PleaseExplain name="haveCodeOfBusinessEthicsAndConduct">
          <p>
          Please provide a copy of your current code of business ethics and conduct on the following page (Signature).
          </p>
          </PleaseExplain>

        <YesNoField
          label="8. If your company has a written code of business ethics and conduct, does your company provide and require periodic training on its contents to all employees of your company?"
          name="haveCodeTrainingMaterials"
        />
        <PleaseExplain name="haveCodeTrainingMaterials">
          <p>
          Please provide a copy of your most recent code training materials on the following page (Signature).
          </p>
          </PleaseExplain>
      </FormSection>
    </FormStep>
  );
}

export default ComplianceFields;
